export default __webpack_public_path__ + "static/media/flat.ca8d31a5.png";